import React from 'react';
import { DestinationLink } from '@components/common/next-link';
import { Region, Country, TripTypes } from '@model/common';
import { LinkItem } from '@components/sitemap/styles';
import { useI18NextContext } from '@components/hooks';
import { TestId } from '@components/test-ids';
import { SectionTitle } from '@components/common/section-title';

export interface SitemapTripTypesProps {
  destination: Region | Country;
  tripTypes: Array<TripTypes>;
}

export const SitemapTripTypes = ({ destination, tripTypes }: SitemapTripTypesProps) => {
  const t: any = useI18NextContext();
  const { display, path } = destination;

  return (
    <div data-testid={TestId.sitemap.tripTypes.container}>
      <SectionTitle heading={t('sitemap__trip-types--title', { destination: display })} />
      {tripTypes.map((tripType: TripTypes) => (
        <LinkItem data-testid={TestId.sitemap.tripTypes.link} key={tripType}>
          <DestinationLink path={path} tripType={tripType}>
            {`${display} ${t(tripType)}`}
          </DestinationLink>
        </LinkItem>
      ))}
    </div>
  );
};
